import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { ContentBox } from "../../components/layout/content";
import { LoginedLayout } from "../../components/layout/loginLayout";
import { HeaderTitle } from "../../components/styled-components";
import { GET, POST } from "../../services";
import { ADDFREEGIFT, GETALLPRODUCT, GETWAITHOLD } from "../../services/path";

const { Option } = Select;
interface OrderData {
  invoiceNo: string;
  orderNo: string;
  SoNo: string;
  optStatusID: number;
}
interface ProductList {
  SKU: string;
  itemName: string;
  sizeName: string;
  sizeID: number;
}

interface DataSubmit {
  orderList: string[];
  remark: string;
  itemName: string;
  itemSize: string;
  qty: number;
  sku: string;
}

const Addsku = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState<OrderData[]>([]);
  const [skuAll, setSkuall] = useState<ProductList[]>([]);
  const fetchOrderWait = async () => {
    try {
      const resultWait = await GET(GETWAITHOLD); //GETWAITHOLD
      if (resultWait.result.length > 0) {
        const filteredData = resultWait.result.filter((item: OrderData) => item.optStatusID === 10);
        setData(filteredData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const resultProduct = async () => {
    try {
      const resultProduct = await GET(GETALLPRODUCT); //GETALLPRODUCT
      if (resultProduct.result.length > 0) {
        setSkuall(resultProduct.result);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchOrderWait();
    resultProduct();
  }, []);

  const [loading, setLoading] = useState(false);
  const [selectedSku, setSelectedSku] = useState<string>("");
  const [remark, setRemark] = useState<string>("");
  const [selectedNameSku, setSelectedNameSku] = useState<string>("");
  const [itemsize, setItemsize] = useState<string>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);
  const generateColumn = (
    title: string,
    dataIndex: keyof OrderData,
    key: keyof OrderData,
    filterable = false,
  ): ColumnsType<OrderData>[0] => ({
    title,
    dataIndex,
    key,
    sorter: (a: OrderData, b: OrderData) => {
      const aValue = a[dataIndex] ?? "";
      const bValue = b[dataIndex] ?? "";
      return aValue.toString().localeCompare(bValue.toString());
    },
    render: (value) => {
      if (dataIndex === "optStatusID") {
        if (value === 7) return "waiting";
        if (value === 10) return "hold";
      }
      return value;
    },

    ...(filterable && {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${title}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value: string | number | boolean | bigint, record: OrderData) => {
        return record[dataIndex]?.toString().toLowerCase().includes(value.toString().toLowerCase());
      },
    }),
  });

  const handleCheckboxChange = (orderNumber: string, checked: boolean) => {
    setSelectedOrders((prev) => {
      if (checked) {
        return [...prev, orderNumber]; // Add to selected orders
      } else {
        return prev.filter((order) => order !== orderNumber); // Remove from selected orders
      }
    });
  };

  // Handle SKU selection
  const handleSkuChange = (value: string) => {
    setSelectedSku(value);
    const selectedItem = skuAll.find((item) => item.SKU === value);
    if (selectedItem) {
      setSelectedNameSku(selectedItem.itemName);
      setItemsize(selectedItem.sizeName);
      form.setFieldsValue({ itemName: selectedItem.itemName });
    }
  };

  // Handle namesku selection
  const handleNameSkuChange = (value: string) => {
    setSelectedNameSku(value);
    const selectedItem = skuAll.find((item) => item.itemName === value);
    if (selectedItem) {
      setSelectedSku(selectedItem.SKU); // Set the corresponding SKU
      setItemsize(selectedItem.sizeName);
      form.setFieldsValue({ SKU: selectedItem.SKU });
    }
  };

  // Handle QTY change
  const handleQtyChange = (value: number | null) => {
    if (value !== null) {
      setQuantity(value);
    }
  };

  const handleRemark = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRemark(e.target.value);
  };

  const submitdateAdd = async (data: DataSubmit) => {
    setLoading(true);
    try {
      const resultAdddata = await POST(ADDFREEGIFT, data); //ADDFREEGIFT
      if (resultAdddata.result.success !== null) {
        setLoading(false);
        message.success(`บันทึกสำเร็จ`);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        message.error(`พบข้อผิดพลาด`);
      }
    } catch (error) {
      message.error(`พบข้อผิดพลาด`);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = () => {
    if (selectedOrders.length === 0) {
      message.error(`กรุณาเลือก order `);
    } else if (remark === "") {
      message.error("กรุณากรอกรายละเอียด");
    } else {
      const data = {
        orderList: selectedOrders,
        remark: remark,
        itemName: selectedNameSku,
        itemSize: itemsize,
        qty: quantity,
        sku: selectedSku,
      };

      submitdateAdd(data);
    }
  };

  const columns: ColumnsType<OrderData> = [
    {
      title: "Select",
      key: "select",
      render: (text: string, record: OrderData) => (
        <Checkbox onChange={(e) => handleCheckboxChange(record.orderNo, e.target.checked)} />
      ),
      width: "50px",
    },

    generateColumn("Order Number", "orderNo", "orderNo", true),
    generateColumn("Sales ID", "SoNo", "SoNo", true),
    generateColumn("Status", "optStatusID", "optStatusID", false),
    generateColumn("Invoice", "invoiceNo", "invoiceNo", true),
  ];

  return (
    <LoginedLayout>
      <ContentBox>
        <Spin spinning={loading}>
          <HeaderTitle>
            <h2>Add SKU(Holder)</h2>
          </HeaderTitle>
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            style={{ marginLeft: "30px", marginRight: "30px" }}
          >
            <Row gutter={10}>
              <Col span={11}>
                <Form.Item
                  name="SKU"
                  label="SKU"
                  rules={[{ required: true, message: "กรุณาเลือก SKU!" }]}
                >
                  <Select
                    showSearch
                    value={selectedSku}
                    onChange={handleSkuChange}
                    placeholder="Select SKU"
                    filterOption={(input, option) =>
                      (option?.value as string).toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {skuAll.map((item) => (
                      <Option key={item.SKU} value={item.SKU}>
                        {item.SKU}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={11}>
                <Form.Item
                  name="itemName"
                  label="Item Name"
                  rules={[{ required: true, message: "กรุณากรอก Item name!" }]}
                >
                  <Select
                    showSearch
                    value={selectedNameSku}
                    onChange={handleNameSkuChange}
                    placeholder="Select NameSKU"
                    filterOption={(input, option) =>
                      (option?.value as string).toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {skuAll.map((item) => (
                      <Option key={item.itemName} value={item.itemName}>
                        {item.itemName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item
                  name="QTY"
                  label="QTY"
                  rules={[{ required: true, message: "กรุณากรอก QTY!" }]}
                >
                  <InputNumber min={1} value={quantity} onChange={handleQtyChange} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="remark"
                  label="Remark"
                  rules={[{ required: true, message: "กรุณากรอก remark!" }]}
                >
                  <Input maxLength={250} showCount onChange={handleRemark} value={remark} />
                </Form.Item>
              </Col>
            </Row>

            <div className="table-add-sku-holder">
              <Table dataSource={data} columns={columns} scroll={{ x: 750 }} pagination={false} />
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ color: "#ffffff", backgroundColor: "#34C759" }}
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </ContentBox>
    </LoginedLayout>
  );
};

export default Addsku;
